<nz-layout  *ngIf="!showMenu">
  <!-- header -->
  <div id="header-bottom" class="shadow-lg bg-white">
    <div class="flex items-center p-3 shadow-lg justify-center">
      <div class="flex header-esign justify-between items-center container !py-1">
        <div class="w-[100px]">
          <a href="https://intrustca.vn" alt="">
            <img
              src="./assets/images/logo/logo_intrust.webp"
              class="logo-intrust"
            />
          </a>
        </div>
        <div class="div-title-header">
          <span class="title-header">NỀN TẢNG KÝ SỐ - ICA PLATFORM</span>
        </div>
      </div>
    </div>
  </div>
  <!-- content -->
  <nz-content>
    <div id="content" class="inner-content">
      <router-outlet></router-outlet>
    </div>
  </nz-content>

</nz-layout>

